import React, { useEffect, useState } from 'react'
import { Drawer, notification } from 'antd'
import PropTypes from 'prop-types'
import { useData } from '../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { Form, Input, Select, } from 'antd'
import { CTAButton } from '../components'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

const { Option } = Select

/**
 * Drawer to add a new cookie 
 */
const AddNewCookie = ({ close, visible }) => {

    const [error, setError] = useState(null)
    const [form] = Form.useForm()

    const data = useData()
    const cookies = data.cookies()
    const classes = useStyles()
    const [accountKeys, setNewAccountKeys] = useState([])
    const tools = data.tools()
    const getAccountKeys = async () => {
        try {
            const accountKeys = await tools.getcookiekeys()
            setNewAccountKeys(accountKeys)
        } catch (error) {
        }

    }
    useEffect(() => {
        getAccountKeys()
        // eslint-disable-next-line
    }, [])


    const { promiseInProgress } = usePromiseTracker()

    const createCookie = (vals) => {
        setError(null)


        const { parameters = [] } = vals
        const params = {}


        try {
            const cookies_value = JSON.parse(vals['cookie_value'])
            let cookeObject = {}
            cookies_value.forEach(item => {
                cookeObject[item.name] = item.value;
            });
            const cookieStr = JSON.stringify(cookeObject);
            vals['cookie_value'] = cookieStr
            for (let param of parameters) {
                const { param_key, param_value } = param

                params[param_key] = param_value
            }
            if (vals['is_active']) {
                vals['is_active'] = "True"
            }else{
                vals['is_active'] = "False"
            }
            
            trackPromise(
                cookies.createCookie({ ...vals, parameters: params })
                    .then(cookies => {
                        close(cookies)
                        notification.success({
                            message: "Cookie created successfully."
                        })
                    })
                    .catch(err => {
                        setError("An error occured")
                    })
            )
        }
        catch (e) {
            notification.error({ message: 'Cookies format is not matching' })
        }

    }

    return (
        <Drawer
            visible={visible}
            title="Create a Cookie"
            onClose={close}
            placement="right"
            closable={true}
            width={350}
        >
            <Form
                layout="vertical"
                onFinish={createCookie}
                form={form}
            >
                <Form.Item label="Account Type" name="account_type" rules={[{ required: true, message: "Account Type is required" }]}>
                    <Select>
                        {
                            accountKeys.map(t => <Option value={t[0]} key={t[1]}>{t[1]}</Option>)
                        }
                    </Select>
                </Form.Item>
                <Form.Item label="Cookie Name" name="name" rules={[{ required: true, message: "Cookie name is required" }]}>
                    <Input placeholder="user@email.com" />
                </Form.Item>
                <Form.Item label="Cookie Value" name="cookie_value" rules={[{ required: true, message: "Cookie value is required" }]}>
                    <Input.TextArea rows={10} placeholder='[
                        {
                            "domain": ".linkedin.com",
                            "expirationDate": 1652635742.450366,
                            "hostOnly": false,
                            "httpOnly": false,
                            "name": "_guid",
                            "path": "/",
                            "sameSite": "no_restriction",
                            "secure": true,
                            "session": false,
                            "storeId": "0",
                            "value": "3eb1e61a-abf6-4d5e-9810-6ba7f3ea0cbc",
                            "id": 2
                        }]'/>
                </Form.Item>

                <Form.Item >
                    <CTAButton type="submit" loading={promiseInProgress}>Submit</CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item >
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }
            </Form>
        </Drawer>
    )
}


AddNewCookie.propTypes = {
    /** Control visibility of the drawer */
    visible: PropTypes.bool,
    close: PropTypes.func,

}
export default AddNewCookie